// extracted by mini-css-extract-plugin
module.exports = {"root":"SucessForm_root__23EFJ","container":"SucessForm_container__1EDNc"};